import { IMAGE_CONFIG } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { enableProdMode, ErrorHandler, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, TitleStrategy, withComponentInputBinding, withPreloading } from '@angular/router';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { AppModule } from 'app';
import { AppRootComponent } from 'app/core/app-root.component';
import { NotificationsModule } from 'app/core/notifications';
import { CustomTitleStrategy } from 'app/shared';
import { environment } from 'environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppRootComponent, {
    providers: [
        importProvidersFrom(AppModule),
        importProvidersFrom(NotificationsModule),
        provideZonelessChangeDetection(),
        provideHttpClient(),
        provideRouter([], withPreloading(PreloadAllModules), withComponentInputBinding()),
        { provide: IMAGE_CONFIG, useValue: { disableImageSizeWarning: true } },
        { provide: ErrorHandler, useValue: createErrorHandler({ logErrors: true, showDialog: false }) },
        { provide: TitleStrategy, useClass: CustomTitleStrategy },
        TraceService,
    ]
});
